import { render, staticRenderFns } from "./StockCards.vue?vue&type=template&id=648ca0d6&"
import script from "./StockCards.vue?vue&type=script&lang=js&"
export * from "./StockCards.vue?vue&type=script&lang=js&"
import style0 from "./StockCards.vue?vue&type=style&index=0&id=648ca0d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports